import { useNavigate } from "react-router-dom";

const SuccessPage = ({ paymentLink, closeModal, t }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center px-4 py-12">
      <div className="max-w-md text-center">
        <div className="mb-6">
          <div className="flex items-center justify-center w-24 h-24 mx-auto bg-green-100 rounded-full">
            <i className="text-5xl text-green-500 fa-solid fa-check"></i>
          </div>
        </div>
        <h2 className="mb-4 text-3xl font-bold text-gray-800">{t("booking_success") || "Booking Successful!"}</h2>
        <p className="mb-8 text-gray-600">
          {t("booking_success_message") ||
            "Your booking has been successfully submitted. Please complete the payment to confirm your reservation."}
        </p>
        {paymentLink && (
          <a
            href={paymentLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-3 mb-4 font-bold text-white transition-colors bg-blue-500 rounded hover:bg-blue-600"
          >
            {t("open_payment_link") || "Open Payment Link"}
          </a>
        )}
        <button
          onClick={() => navigate("/")}
          className="block w-full px-8 py-3 font-bold text-white transition-colors bg-[#f5272b] rounded hover:bg-red-600"
        >
          {t("close") || "Close"}
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;
